// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAjvyE0KvK1me8MfaN3xd0OJTz4Zn51_cY",
  authDomain: "mrproptek-4f5a2.firebaseapp.com",
  projectId: "mrproptek-4f5a2",
  storageBucket: "mrproptek-4f5a2.firebasestorage.com",
  messagingSenderId: "355237122187",
  appId: "1:355237122187:web:3ecf11e9ddd08c52c2848e",
  measurementId: "G-R6J84C2YCE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      // "BJvVb0atLhdaqH2xKEatecno3YzxZk_AfZ4XD6taimOocY2eejzMDNMOHREhUtLGlyWxA6b5PB6QA_QwsmP5ewE",
    });
    return token;

  }
};
